/* Publish by EComposer at 2025-08-02 22:00:30*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vncq9s8qh6m"]=  window.__ectimmers["ecom-vncq9s8qh6m"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vncq9s8qh6m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vncq9s8qh6m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dze23b3bx4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dze23b3bx4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-prfbgwdvlxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-prfbgwdvlxs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-icyiidt7iwm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-icyiidt7iwm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e9ung06s1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e9ung06s1m', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);};window.addEventListener("load",()=>{
                let isAdmin = false;
                if(document.querySelector("#admin-bar-iframe")){
                    isAdmin = true;
                }
                if(!isAdmin) {
                    if(window.EComposerBrand) {
                        return;
                    } else {
                        window.EComposerBrand = true;
                    }
                }
                let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 11px","width: 100%","text-align: center","opacity: 1","text-indent: 0","color: rgba(18, 18, 18, 0.75)","background: transparent","opacity: 0.8",""].join(" !important;")),b.innerHTML="Built with <a style='color: currentColor;text-decoration: none;' href=\"https://ecomposer.io/?utm_source=client-site&utm_medium=footer&utm_campaign=footer_branding&utm_term=links&utm_content="+window.location.origin+"\" target=\"_blank\">EComposer</a>" + (isAdmin ? ". Contact us or upgrade to remove branding" :""),a.appendChild(b)
            });